module.exports = __webpack_public_path__ + "media/kor.4e9af36e.mp4";